/**
 * Split Priority trigger SQL into plain-text runs and #INCLUDE directives.
 *
 * Grammar, verified against 63,094 occurrences in the real corpus:
 *   #INCLUDE <ENAME>/<TRIGNAME>            -> form-scope trigger
 *   #INCLUDE <ENAME>/<COLUMN>/<TRIGNAME>   -> column-scope trigger
 * 35,500 of the first shape, 27,591 of the second. Handling only the
 * two-part shape misses 44% of the directives.
 *
 * Form names use the server's IDENT_RE class, which admits lowercase
 * (`func`) and suffixes (`TRANSORDER_m`). Trigger and column names admit
 * hyphens, because CHOOSE-FIELD and SEARCH-DES-FIELD are real targets.
 *
 * Known cosmetic limit: 213 of 63,094 directives sit behind a /* comment
 * and will be chipped like any other. Writing a Priority-SQL comment
 * parser to suppress 0.3% of chips in a read-only viewer is not worth it;
 * expanding one shows real trigger source either way.
 */
export const INCLUDE_RE =
  /#INCLUDE\s+([A-Za-z][A-Za-z0-9_]{0,62})\/([A-Za-z0-9_-]{1,64})(?:\/([A-Za-z0-9_-]{1,64}))?/g;

export function parseIncludes(sql) {
  const out = [];
  if (!sql) return out;
  let last = 0;
  for (const m of sql.matchAll(INCLUDE_RE)) {
    if (m.index > last) out.push({ type: 'text', text: sql.slice(last, m.index) });
    const [raw, form, second, third] = m;
    // Two-part: `second` IS the trigger name. Three-part: it is the column.
    out.push({
      type: 'include',
      raw,
      form,
      column: third ? second : '',
      name: third || second,
    });
    last = m.index + raw.length;
  }
  if (last < sql.length) out.push({ type: 'text', text: sql.slice(last) });
  return out;
}
